// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Input } from 'semantic-ui-react'

export default class AppInfo extends Component {
  render () {
    let { appname, description } = this.props
    return (
      <div className='dashboard'>
        <div className='mbs'>
          <Input
            label='App name'
            fluid={true}
            type='text'
            onChange={this.props.handleChange}
            value={appname}
            name='appname'
          />
        </div>
        <Input
          maxLength='80'
          label='Subtitle (optional)'
          fluid={true}
          type='text'
          onChange={this.props.handleChange}
          name='description'
          value={description}
        />
      </div>
    )
  }
}
